const assetClassificationInputFields = [
  {
    name: "category",
    label: "Categoria",
  },
  {
    name: "className",
    label: "Classe",
  },
  {
    name: "subcategory",
    label: "Subclasse",
  },
  // {
  //   name: "minConsAllocation",
  //   label: "Mínimo (Conservador)",
  //   type: "percentage",
  //   width: 230,
  // },
  {
    name: "recConsAllocation",
    label: "Recomendado (Conservador)",
    type: "percentage",
    width: 230,
  },
  // {
  //   name: "maxConsAllocation",
  //   label: "Máximo (Conservador)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "minConsModAllocation",
  //   label: "Mínimo (Mod-Conservador)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "recConsModAllocation",
  //   label: "Recomendado (Mod-Conservador)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "maxConsModAllocation",
  //   label: "Máximo (Mod-Conservador)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "minModAllocation",
  //   label: "Mínimo (Moderado)",
  //   type: "percentage",
  //   width: 230,
  // },
  {
    name: "recModAllocation",
    label: "Recomendado (Moderado)",
    type: "percentage",
    width: 230,
  },
  // {
  //   name: "maxModAllocation",
  //   label: "Máximo (Moderado)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "minModAggrAllocation",
  //   label: "Mínimo (Mod-Arrojado)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "recModAggrAllocation",
  //   label: "Recomendado (Mod-Arrojado)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "maxModAggrAllocation",
  //   label: "Máximo (Mod-Arrojado)",
  //   type: "percentage",
  //   width: 230,
  // },
  // {
  //   name: "minAggrAllocation",
  //   label: "Mínimo (Arrojado)",
  //   type: "percentage",
  //   width: 230,
  // },
  {
    name: "recAggrAllocation",
    label: "Recomendado (Arrojado)",
    type: "percentage",
    width: 230,
  },
  // {
  //   name: "maxAggrAllocation",
  //   label: "Máximo (Arrojado)",
  //   type: "percentage",
  //   width: 230,
  // },
];

export default assetClassificationInputFields;
